import React from 'react';

import * as ST from './styled';

export interface IArrowProps {
    previousSlide?: () => void,
    nextSlide?: () => void,
}

const DefaultArrow = ({ previousSlide, nextSlide }: IArrowProps) => {
    return (
        <ST.Wrapper onClick={previousSlide || nextSlide}>
            <ST.ArrowSvg type={previousSlide ? 'left' : 'right'} />
        </ST.Wrapper>
    );
};

export default DefaultArrow;
